import { render, staticRenderFns } from "./RoleManager.vue?vue&type=template&id=74d39ab1&scoped=true&"
import script from "./RoleManager.vue?vue&type=script&lang=js&"
export * from "./RoleManager.vue?vue&type=script&lang=js&"
import style0 from "./RoleManager.vue?vue&type=style&index=0&id=74d39ab1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d39ab1",
  null
  
)

export default component.exports